import { Component, Input } from "@angular/core";

@Component({
    selector: "labeled-field",
    templateUrl: "./labeledField.tmpl.html",
    styleUrls: [
        "./labeledField.component.scss"
    ],
    standalone: false
})
export class LabeledFieldComponent
{
    @Input() readonly label: string;
}
